<div class="fixedContainer">

  <div class="backgroundImage"></div>

  <span class="startButton" [routerLink]="['/game/welcome']"></span>

</div>
